import { ComputedRef, ref, onMounted, watch, Ref } from '@vue/composition-api';
import { useWxSubscribe } from '@/hooks/use-wxsubscribe';

/**
 * 券详情展示订阅入口处理
 * @param isAllowExchangePrize // 是否允许兑换券
 * @param isDialogBtnDisabled  // 详情按钮是否可点击
 * @param isShowCouponInfoDialog // 是否展示券详情
 * @returns
 */
export function useCouponDetailSubscribe(
  isAllowExchangePrize: ComputedRef<boolean>,
  isDialogBtnDisabled: ComputedRef<boolean>,
  isShowCouponInfoDialog: Ref<boolean>,
) {
  // 是否展示订阅入口
  const isShowSubcribe = ref(false);
  // 订阅入口展示是一个异步的过程，这里标识订阅检测完成
  const isSubcribeInited = ref(false);
  const wxSubscribe = useWxSubscribe();

  async function initSubcribeState() {
    isSubcribeInited.value = false;
    const isShowSubc = await wxSubscribe.checkShouldShowSubscribe();
    if (isShowSubc) {
      wxSubscribe.markSubcribeBtnView();
    }
    // 券详情页展示订阅按钮的条件：
    // 1、微信支持订阅  2、在允许时段 3、有未订阅的模版 4、印花不可兑换券时(印花可兑时，订阅按钮在订阅成功弹框上展示) 5、按钮可点击
    isShowSubcribe.value = isShowSubc && !isAllowExchangePrize.value && !isDialogBtnDisabled.value;
    isSubcribeInited.value = true;
  }

  onMounted(() => {
    initSubcribeState();
  });

  watch(isShowCouponInfoDialog, () => {
    // 这里需要在弹框展示后再更新一遍订阅状态
    if (isShowCouponInfoDialog.value) {
      initSubcribeState();
    }
  });
  return {
    isShowSubcribe,
    isSubcribeInited,
  };
}
